<template>
  <header class="page-header">
    <h1 class="title">{{ title }}</h1>
    <slot></slot>
  </header>
</template>

<script>
export default {
  props: ["title"]
};
</script>

<style lang="scss" scoped>
.page-header {
  border-bottom: 1px solid #e0e0e0;
  padding: 20px 30px;

  > .title {
    margin-bottom: 0;

    font-size: 24px;
    line-height: 1.6;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/PageHeader.vue